import axios from "axios";

export default {

    /**
     * Método para guardar una nueva disponibilidad de equipos
     * @param {Object} params - Parámetros de la disponibilidad
     * @returns {Promise} - Respuesta de la API
     */
    async guardarDisponibilidadEquipos(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/guardar-entidad-verificada",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                nombre_entidad: "disponibilidad_equipos",
                id_version: "29",
                data: {
                    fecha: params.fecha,
                    proveedor: parseInt(params.proveedor),
                    regional: params.regional,
                    sede_de_equipos: params.sede_de_equipos,
                    observacion: params.observacion || "",
                    conc_bajo_flujo_dia: parseInt(params.conc_bajo_flujo_dia),
                    conc_bajo_flujo_noche: parseInt(params.conc_bajo_flujo_noche),
                    conc_alto_flujo_dia: parseInt(params.conc_alto_flujo_dia),
                    conc_alto_flujo_noche: parseInt(params.conc_alto_flujo_noche),
                    conc_portatil_dia: parseInt(params.conc_portatil_dia),
                    conc_portatil_noche: parseInt(params.conc_portatil_noche),
                    aspirador_dia: parseInt(params.aspirador_dia),
                    aspirador_noche: parseInt(params.aspirador_noche),
                    nebulizador_dia: parseInt(params.nebulizador_dia),
                    nebulizador_noche: parseInt(params.nebulizador_noche),
                    oximetro_adul_dia: parseInt(params.oximetro_adul_dia),
                    oximetro_adul_noche: parseInt(params.oximetro_adul_noche),
                    oximetro_ped_dia: parseInt(params.oximetro_ped_dia),
                    oximetro_ped_noche: parseInt(params.oximetro_ped_noche),
                    bala_portatil_dia: parseInt(params.bala_portatil_dia),
                    bala_portatil_noche: parseInt(params.bala_portatil_noche),
                    regulador_ahorrador_dia: parseInt(params.regulador_ahorrador_dia),
                    regulador_ahorrador_noche: parseInt(params.regulador_ahorrador_noche),
                    paquete_pediatrico_dia: parseInt(params.paquete_pediatrico_dia),
                    paquete_pediatrico_noche: parseInt(params.paquete_pediatrico_noche)
                }
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            return false;
        }
    },

    /**
     * Método para editar una disponibilidad de equipos existente (actualización completa)
     * @param {Object} params - Parámetros de la disponibilidad incluyendo id_metadata
     * @returns {Promise} - Respuesta de la API
     */
    async editarDisponibilidadEquipos(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/editar-entidad-verificada",
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                nombre_entidad: "disponibilidad_equipos",
                id_version: "29",
                id_metadata: params.id_metadata,
                data: {
                    fecha: params.fecha,
                    proveedor: parseInt(params.proveedor),
                    regional: params.regional,
                    sede_de_equipos: params.sede_de_equipos,
                    observacion: params.observacion || "",
                    conc_bajo_flujo_dia: parseInt(params.conc_bajo_flujo_dia),
                    conc_bajo_flujo_noche: parseInt(params.conc_bajo_flujo_noche),
                    conc_alto_flujo_dia: parseInt(params.conc_alto_flujo_dia),
                    conc_alto_flujo_noche: parseInt(params.conc_alto_flujo_noche),
                    conc_portatil_dia: parseInt(params.conc_portatil_dia),
                    conc_portatil_noche: parseInt(params.conc_portatil_noche),
                    aspirador_dia: parseInt(params.aspirador_dia),
                    aspirador_noche: parseInt(params.aspirador_noche),
                    nebulizador_dia: parseInt(params.nebulizador_dia),
                    nebulizador_noche: parseInt(params.nebulizador_noche),
                    oximetro_adul_dia: parseInt(params.oximetro_adul_dia),
                    oximetro_adul_noche: parseInt(params.oximetro_adul_noche),
                    oximetro_ped_dia: parseInt(params.oximetro_ped_dia),
                    oximetro_ped_noche: parseInt(params.oximetro_ped_noche),
                    bala_portatil_dia: parseInt(params.bala_portatil_dia),
                    bala_portatil_noche: parseInt(params.bala_portatil_noche),
                    regulador_ahorrador_dia: parseInt(params.regulador_ahorrador_dia),
                    regulador_ahorrador_noche: parseInt(params.regulador_ahorrador_noche),
                    paquete_pediatrico_dia: parseInt(params.paquete_pediatrico_dia),
                    paquete_pediatrico_noche: parseInt(params.paquete_pediatrico_noche)
                }
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            return false;
        }
    },

    /**
     * Método para editar campos específicos de una disponibilidad de equipos (actualización parcial)
     * @param {Object} params - Parámetros parciales de la disponibilidad incluyendo id_metadata
     * @returns {Promise} - Respuesta de la API
     */
    async editarDisponibilidadParcial(params) {
        // Construir objeto data solo con los campos que vienen en params
        const data = {};
        
        // Lista de campos posibles
        const campos = [
            'fecha', 'proveedor', 'regional', 'sede_de_equipos', 'observacion',
            'conc_bajo_flujo_dia', 'conc_bajo_flujo_noche', 
            'conc_alto_flujo_dia', 'conc_alto_flujo_noche',
            'conc_portatil_dia', 'conc_portatil_noche',
            'aspirador_dia', 'aspirador_noche',
            'nebulizador_dia', 'nebulizador_noche',
            'oximetro_adul_dia', 'oximetro_adul_noche',
            'oximetro_ped_dia', 'oximetro_ped_noche',
            'bala_portatil_dia', 'bala_portatil_noche',
            'regulador_ahorrador_dia', 'regulador_ahorrador_noche',
            'paquete_pediatrico_dia', 'paquete_pediatrico_noche'
        ];

        // Solo agregar los campos que existan en params
        campos.forEach(campo => {
            if (params[campo] !== undefined && params[campo] !== null) {
                // Convertir a número los campos numéricos
                if (campo === 'proveedor' || campo.includes('_dia') || campo.includes('_noche')) {
                    data[campo] = parseInt(params[campo]);
                } else {
                    data[campo] = params[campo];
                }
            }
        });

        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/editar-entidad-verificada-por-metadata-especifica",
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                nombre_entidad: "disponibilidad_equipos",
                id_version: "29",
                id_metadata: params.id_metadata,
                data: data
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            return false;
        }
    },

    /**
     * Método para consultar disponibilidades con filtros (POST con paginación)
     * @param {Object} params - Parámetros de consulta con filtros
     * @returns {Promise} - Respuesta de la API con los datos paginados
     */
    async consultarDisponibilidadEquipos(params) {
        // Construir el objeto where para los filtros
        const where = params.where || [];
        
        // Construir relaciones si se necesitan
        const relaciones = params.relaciones || [];

        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/get-query-by-entidades",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                entidad: {
                    nombre: "disponibilidad_equipos",
                    idVersion: 29,
                    order: {
                        column: params.orderBy || "id",
                        type: params.typeOrder || "desc"
                    },
                    size: params.size || 10,
                    page: params.page || 1,
                    where: where,
                    relaciones: relaciones
                }
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            return false;
        }
    },

    /**
     * Método para consultar disponibilidades con filtros (GET con query params)
     * @param {Object} params - Parámetros de consulta con filtros
     * @returns {Promise} - Respuesta de la API con los datos paginados
     */
    async getDisponibilidadEquipos(params) {
        const baseUrl = process.env.VUE_APP_BASE_API + "/negocio/get-meta-data-entidad";
        const queryParams = new URLSearchParams({
            nombreEntidad: "disponibilidad_equipos",
            idVersion: "29",
            size: params.size || 10,
            page: params.page || 1,
            orderBy: params.orderBy || "id",
            typeOrder: params.typeOrder || "desc"
        });

        // Agregar parámetros opcionales solo si existen
        if (params.filterByColum) queryParams.append('filterByColum', params.filterByColum);
        if (params.filter) queryParams.append('filter', params.filter);
        if (params.dateBy) queryParams.append('dateBy', params.dateBy);
        if (params.startDate) queryParams.append('startDate', params.startDate);
        if (params.endDate) queryParams.append('endDate', params.endDate);

        const config = {
            url: `${baseUrl}?${queryParams.toString()}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    /**
     * Método para consultar una disponibilidad específica por ID
     * @param {Object} params - Objeto con metadataId
     * @returns {Promise} - Respuesta de la API con el registro específico
     */
    async getDisponibilidadPorId(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + 
                `/negocio/get-meta-data-entidad-id?nombreEntidad=disponibilidad_equipos&metadataId=${params.metadataId}&idVersion=29`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    /**
     * Método para obtener metadata con relaciones entre entidades
     * @param {Object} params - Parámetros con estructura padre-hijo
     * @returns {Promise} - Respuesta de la API con las relaciones
     */
    async getMetadataPorEntidad(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/get-metadata-by-entidad",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                padre: {
                    nombre: "disponibilidad_equipos",
                    idVersion: 29,
                    filtros: params.filtros || []
                },
                hijos: params.hijos || []
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    /**
     * Método para realizar consultas complejas entre entidades relacionadas
     * @param {Object} params - Parámetros con estructura padre-hijo y filtros
     * @returns {Promise} - Respuesta de la API con los resultados de la query
     */
    async getQueryPorEntidades(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/get-query-by-entidades",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                padre: {
                    nombre: "disponibilidad_equipos",
                    idVersion: 29,
                    filtros: params.filtros || []
                },
                hijos: params.hijos || []
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    /**
     * Método para cargar disponibilidades masivamente desde archivo CSV
     * @param {FormData} formData - FormData con el archivo y estructura
     * @returns {Promise} - Respuesta de la API
     */
    async guardarDisponibilidadDesdeCSV(formData) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/guardar-entidad-archivos",
            method: 'POST',
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: formData
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            return false;
        }
    },

    /**
     * Método para guardar múltiples disponibilidades de equipos (carga masiva)
     * @param {Object} params - Objeto con array de registros
     * @returns {Promise} - Respuesta de la API
     */
    async guardarDisponibilidadesMasivo(params) {
        try {
            const registros = params.registros || [];
            
            if (!registros || registros.length === 0) {
                return { exitosos: 0, fallidos: 0, errores: ['No hay registros para procesar'] };
            }

            const config = {
                url: process.env.VUE_APP_BASE_API + "/negocio/guardar-disponibilidad-masivo",
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    Authorization: localStorage.getItem('userToken'),
                },
                data: JSON.stringify({
                    nombre_entidad: "disponibilidad_equipos",
                    id_version: "29",
                    registros: registros
                }),
            };
            
            const response = await axios(config);

            if (response.status == 200) {
                return (await response).data;
            } else {
                return { exitosos: 0, fallidos: registros.length, errores: ['Error en la respuesta del servidor'] };
            }
        } catch (error) {
            console.error('Error en guardarDisponibilidadesMasivo:', error);
            return { exitosos: 0, fallidos: params.registros?.length || 0, errores: [error.message] };
        }
    },

    /**
     * Método para actualizar disponibilidades masivamente desde archivo CSV
     * @param {FormData} formData - FormData con el archivo y estructura
     * @returns {Promise} - Respuesta de la API
     */
    async actualizarDisponibilidadDesdeCSV(formData) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/actualizar-entidad-archivos",
            method: 'POST',
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: formData
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            return false;
        }
    },

    /**
     * Método para filtrar disponibilidades por regional
     * @param {Object} params - Objeto con regional y parámetros de paginación
     * @returns {Promise} - Respuesta de la API filtrada por regional
     */
    async getDisponibilidadPorRegional(params) {
        return await this.getDisponibilidadEquipos({
            size: params.size || 10,
            page: params.page || 1,
            filterByColum: 'regional',
            filter: params.regional,
            orderBy: params.orderBy || "id",
            typeOrder: params.typeOrder || "desc"
        });
    },

    /**
     * Método para filtrar disponibilidades por proveedor
     * @param {Object} params - Objeto con proveedor y parámetros de paginación
     * @returns {Promise} - Respuesta de la API filtrada por proveedor
     */
    async getDisponibilidadPorProveedor(params) {
        return await this.getDisponibilidadEquipos({
            size: params.size || 10,
            page: params.page || 1,
            filterByColum: 'proveedor',
            filter: params.proveedor,
            orderBy: params.orderBy || "id",
            typeOrder: params.typeOrder || "desc"
        });
    },

    /**
     * Método para filtrar disponibilidades por sede
     * @param {Object} params - Objeto con sede y parámetros de paginación
     * @returns {Promise} - Respuesta de la API filtrada por sede
     */
    async getDisponibilidadPorSede(params) {
        return await this.getDisponibilidadEquipos({
            size: params.size || 10,
            page: params.page || 1,
            filterByColum: 'sede_de_equipos',
            filter: params.sede,
            orderBy: params.orderBy || "id",
            typeOrder: params.typeOrder || "desc"
        });
    },

    /**
     * Método para filtrar disponibilidades por rango de fechas
     * @param {Object} params - Objeto con startDate, endDate y parámetros de paginación
     * @returns {Promise} - Respuesta de la API filtrada por rango de fechas
     */
    async getDisponibilidadPorFechas(params) {
        return await this.getDisponibilidadEquipos({
            size: params.size || 10,
            page: params.page || 1,
            dateBy: params.dateBy || "createat",
            startDate: params.startDate,
            endDate: params.endDate,
            orderBy: params.orderBy || "id",
            typeOrder: params.typeOrder || "desc"
        });
    }
};
